'use client';
import { fetchRealties } from '@eliadmin/core/src/api/realty/realty-api';
import { useQuery } from '@tanstack/react-query';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import RoomCard from './room-card';
import { Spinner } from '@eliadmin/core/src/components/ui/spinner';

export const RoomsList = ({ excludeRealtyId }: { excludeRealtyId?: number }) => {
  const locale = useLocaleStore(s => s.currentLocale);
  const { data: realties, isLoading } = useQuery({
    queryKey: ['realties'],
    queryFn: () => fetchRealties({ locale }),
  });

  return (
    <div className="grid grid-cols-1 gap-6">
      {isLoading ? (
        <div className="flex h-36 items-center justify-center">
          <Spinner className="h-8 w-8 text-primary" />
        </div>
      ) : (
        realties?.data.map((realty: any) =>
          excludeRealtyId && realty.id === excludeRealtyId ? null : (
            <RoomCard key={realty.id} realty={realty} />
          ),
        )
      )}
    </div>
  );
};
